import { expect } from '$lib/helpers';

export const getUsernameAndTestAppId = (
  usernameSlug?: string,
): [username: string, appId?: string] => {
  const parts = usernameSlug?.slice(1).split('+test') ?? [];

  return [expect(parts[0], 'expected username'), parts[1]];
};
